export enum TnxLoadStatusType {
  CUSTOM = 'CUSTOM',
  FAILURE = 'FAILURE',
  EXPIRING = 'EXPIRING',
  CANCELLED = 'CANCELLED',
  UPDATED = 'UPDATED'
}
